<div class="header">
  <div class="header__start">
    <div class="header-title mat-headline-large">
      {{ title }}
    </div>
    <button class="header-back-button htv-selectable" mat-raised-button color="primary" (click)="goToPreviousPage()">
      <mat-icon>&#xe5c4;</mat-icon>
      <span>{{ 'BACK' | translate }}</span>
    </button>
  </div>
  <div class="header__end">
    <div class="header-time mat-headline-large">
      {{ time$ | async }}
    </div>
    <div class="header-date">
      {{ date | momentp: 'll' }}
    </div>
  </div>
</div>
